// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");

function SurveyPageSearch(props) {
  var __compact = props.compact;
  var onChange = props.onChange;
  var value = props.value;
  var compact = __compact !== undefined ? __compact : false;
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("img", {
                            className: "sb-left-search-icon",
                            src: Image$ReactHooksTemplate.search
                          }),
                      JsxRuntime.jsx("input", {
                            className: "sb-left-search-input",
                            style: value === "" ? ({}) : ({
                                  paddingRight: "2rem"
                                }),
                            placeholder: props.searchPlaceholder,
                            type: "text",
                            value: value,
                            onChange: (function ($$event) {
                                Curry._1(onChange, Utils$ReactHooksTemplate.formTargetValue($$event));
                              })
                          }),
                      value === "" ? null : JsxRuntime.jsx("button", {
                              children: JsxRuntime.jsx("span", {
                                    children: "✕",
                                    className: "text-xs leading-none"
                                  }),
                              "aria-label": "Clear search",
                              className: "absolute right-2 inset-y-0 flex items-center text-gray-400 hover:text-gray-600 focus:outline-none",
                              type: "button",
                              onClick: (function (param) {
                                  Curry._1(onChange, "");
                                })
                            })
                    ],
                    className: "sb-left-search-field"
                  }),
              className: compact ? "" : "sb-left-search",
              style: compact ? ({}) : ({
                    padding: "0"
                  }),
              onClick: (function ($$event) {
                  $$event.stopPropagation();
                })
            });
}

var make = SurveyPageSearch;

exports.make = make;
/* react/jsx-runtime Not a pure module */
